(function () {
  if (customElements.get('jb2-collection')) return;

  function rootUrl() {
    return window.Shopify && window.Shopify.routes
      ? window.Shopify.routes.root
      : '/';
  }

  class JellyBeanCollection extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';

      this.filters = Array.from(this.querySelectorAll('[data-jb2c-filter]'));
      this.items = Array.from(this.querySelectorAll('.jb2c-grid__item'));
      this.count = this.querySelector('[data-jb2c-count]');
      this.countLabel = this.querySelector('[data-jb2c-count-label]');
      this.empty = this.querySelector('[data-jb2c-filter-empty]');
      this.reset = this.querySelector('[data-jb2c-reset]');
      this.liveStatus = this.querySelector('[data-jb2c-live-status]');

      this.filters.forEach((button) => {
        button.addEventListener('click', () => this.applyFilter(button.dataset.jb2cFilter, true));
      });

      this.reset?.addEventListener('click', () => this.applyFilter('all', true));

      this.querySelectorAll('[data-jb2c-add-form]').forEach((form) => {
        form.addEventListener('submit', (event) => this.addToCart(event, form));
      });

      var params = new URL(window.location.href).searchParams;
      var requestedFilter = params.get('shape') || 'all';
      var valid = this.filters.some((button) => button.dataset.jb2cFilter === requestedFilter);
      this.applyFilter(valid ? requestedFilter : 'all', false);
    }

    applyFilter(filter, updateUrl) {
      var visibleCount = 0;

      this.filters.forEach((button) => {
        var active = button.dataset.jb2cFilter === filter;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      this.items.forEach((item) => {
        var card = item.querySelector('[data-jb2c-product]');
        var visible = filter === 'all' || card?.dataset.shape === filter;
        item.hidden = !visible;
        if (visible) visibleCount += 1;
      });

      if (this.count) this.count.textContent = String(visibleCount);
      if (this.countLabel) {
        this.countLabel.textContent = visibleCount === 1
          ? this.dataset.paddleSingular
          : this.dataset.paddlePlural;
      }
      if (this.empty) this.empty.hidden = visibleCount !== 0;

      if (this.liveStatus) {
        var activeButton = this.filters.find((button) => button.dataset.jb2cFilter === filter);
        this.liveStatus.textContent = visibleCount + ' ' +
          (visibleCount === 1 ? this.dataset.paddleSingular : this.dataset.paddlePlural) +
          ' shown for ' + (activeButton?.textContent.trim() || this.dataset.allLabel) + '.';
      }

      if (updateUrl && window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        if (filter === 'all') url.searchParams.delete('shape');
        else url.searchParams.set('shape', filter);
        window.history.replaceState({}, '', url.toString());
      }
    }

    async addToCart(event, form) {
      event.preventDefault();

      var button = form.querySelector('button[type="submit"]');
      var message = form.querySelector('[data-jb2c-card-message]');
      if (!button || button.disabled) return;

      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      if (message) {
        message.textContent = '';
        message.classList.remove('is-error');
      }

      try {
        var response = await fetch(rootUrl() + 'cart/add.js', {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: new FormData(form)
        });
        var item = await response.json();
        if (!response.ok) throw item;

        if (message) message.textContent = this.dataset.addedText;

        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: { product: item, addToCartBtn: button }
        }));

        var cartResponse = await fetch(rootUrl() + 'cart.js', {
          headers: { Accept: 'application/json' }
        });
        var cart = await cartResponse.json();

        window.dispatchEvent(new CustomEvent('11six24:cart-updated', { detail: { cart: cart } }));
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
      } catch (error) {
        if (message) {
          message.textContent = error.description || error.message || this.dataset.errorText;
          message.classList.add('is-error');
        }
      } finally {
        button.removeAttribute('aria-busy');
        button.disabled = false;
      }
    }
  }

  customElements.define('jb2-collection', JellyBeanCollection);
})();
